<template>
    <div id="wrapper">
        <Top></Top>
        <section id="inner-headline">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <h2 class="pageTitle">採用情報</h2>
                    </div>
                </div>
            </div>
        </section>
        <section class="section1">
            <div class="container clearfix">
                <div class="content col-lg-12 col-md-12 col-sm-12 col-xs-12 clearfix">
                    <div class="title"><h2>募集概要</h2></div>
                    <table class="table table-striped" data-effect="fade">
                        <tbody>
                            <tr>
                                <th>募集職種</th>
                                <td>
                                    システムエンジニア<br>
                                    ネットワークエンジニア<br>
                                    プログラマー
                                </td>
                            </tr>
                            <tr>
                                <th>勤務地</th>
                                <td>
                                    本社または首都圏のクライアントでの勤務となります。<br>
                                    ※勤務地希望は100％相談に応じます。
                                </td>
                            </tr>
                            <tr>
                                <th>勤務時間</th>
                                <td>
                                    9:00-18:00<br>
                                    ※勤務時間は現場により異なります。<br>
                                    ※お客様自体の労務管理も厳しいため、残業は少なめです。
                                </td>
                            </tr>
                            <tr>
                                <th>仕事内容</th>
                                <td>
                                    基本設計、詳細設計、製造、テスト、保守<br>
                                    ネットワーク設計、構築、保守
                                </td>
                            </tr>
                            <tr>
                                <th>給与</th>
                                <td>
                                    20～70万　※スキル、経験、弊社の規制により決定。<br>
                                    残業手当<br>
                                    資格手当<br>
                                    通勤交通費支給　※最大25,000円
                                </td>
                            </tr>
                            <tr>
                                <th>休日・休暇</th>
                                <td>
                                    完全週休2日制（土・日）<br>
                                    祝日<br>
                                    夏季休暇<br>
                                    年末年始休暇（5日間）<br>
                                    慶弔休暇<br>
                                    産休・育児休暇※実績あり
                                </td>
                            </tr>
                            <tr>
                                <th>福利厚生</th>
                                <td>
                                    各種社会保険完備（健康保険・年金保険・雇用保険・労災保険)<br>
                                    社員旅行
                                </td>
                            </tr>
                            <tr>
                                <th>教育制度</th>
                                <td>
                                    新人社員研修<br>
                                    フォローアップ研修<br>
                                    OJT研修<br>
                                    社外研修<br>
                                    資格取得費用補助<br>
                                    ※会社規定による
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>	
        <a href="#" class="scrollup"><i class="fa fa-angle-up active"></i></a>
        <Footer></Footer>
    </div>
</template>

<script>
import Top from "@/components/TopMenu.vue"
import Footer from "@/components/Footer.vue"
export default{
    name: 'Home',
    components: {
        Top,
        Footer
    }
}
</script>
<!-- <script src="../assets/js/jquery.js"></script>
<script src="../assets/js/jquery.easing.1.3.js"></script>
<script src="../assets/js/bootstrap.min.js"></script>
<script src="../assets/js/jquery.fancybox.pack.js"></script>
<script src="../assets/js/jquery.fancybox-media.js"></script>
<script src="../assets/js/portfolio/jquery.quicksand.js"></script>
<script src="../assets/js/portfolio/setting.js"></script>
<script src="../assets/js/jquery.flexslider.js"></script>
<script src="../assets/js/animate.js"></script>
<script src="../assets/js/custom.js"></script>
<script src="../assets/js/owl-carousel/owl.carousel.js"></script>
<script src="../assets/js/easypiechart/easypiechart.min.js"></script>
<script src="../assets/js/nivo-lightbox.js"></script>
<script src="../assets/js/main.js"></script> -->
<!-- <script>
    $(document).ready(function(){
        $(".headerpage").load("header.html");
        $(".footerpage").load("footer.html");
    });
</script> -->
<!--
<script>
    // You can also use "$(window).load(function() {"
    $(function () {
      // Slideshow 4
      $("#slider4").responsiveSlides({
        auto: true,
        pager:true,
        nav:true,
        speed: 500,
        namespace: "callbacks",
        before: function () {
          $('.events').append("<li>before event fired.</li>");
        },
        after: function () {
          $('.events').append("<li>after event fired.</li>");
        }
      });

    });
 </script> -->
<!--banner Slider starts Here-->

<style scoped>
</style>